import Button from '@/components/button';
import Picture from '@/components/picture';


export default {
	props: {
		/**
		 * 类型
		 *
		 * pure: 纯色
		 * border: 边框
		 */
		type: {
			type: String,
			default: 'pure'
		},

		theme: {
			type: String,
			default: 'orange'
		},		

		/** 内边距 */
		padding: {
			type: String
		},
	},


	components: {
		'c-button': Button,
		'c-picture': Picture,
	},
};
